var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 15.5C11.866 15.5 15 12.366 15 8.5C15 4.63401 11.866 1.5 8 1.5C4.13401 1.5 1 4.63401 1 8.5C1 12.366 4.13401 15.5 8 15.5ZM8 16.5C12.4183 16.5 16 12.9183 16 8.5C16 4.08172 12.4183 0.5 8 0.5C3.58172 0.5 0 4.08172 0 8.5C0 12.9183 3.58172 16.5 8 16.5Z",
    fill: "#2C62F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 12.5C7 11.9477 7.44772 11.5 8 11.5C8.55228 11.5 9 11.9477 9 12.5C9 13.0523 8.55228 13.5 8 13.5C7.44772 13.5 7 13.0523 7 12.5Z",
    fill: "#2C62F6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.45032 9.30664C7.31067 9.64095 7.24084 10.0895 7.24084 10.6523H8.68176C8.69023 10.043 8.83411 9.57959 9.1134 9.26221L9.89417 8.49414C10.5374 7.82552 10.859 7.14632 10.859 6.45654C10.859 5.68213 10.6199 5.0791 10.1417 4.64746C9.66777 4.21582 9.00549 4 8.15491 4C7.32971 4 6.66532 4.21794 6.16174 4.65381C5.66239 5.08968 5.40849 5.68213 5.40002 6.43115H6.9425C6.9425 6.07992 7.05253 5.80273 7.27258 5.59961C7.49687 5.39225 7.79097 5.28857 8.15491 5.28857C8.53577 5.28857 8.82353 5.39437 9.01819 5.60596C9.21708 5.81331 9.31653 6.11589 9.31653 6.51367C9.31653 6.81413 9.23189 7.09342 9.06262 7.35156C8.9526 7.52083 8.69023 7.80648 8.27551 8.2085C7.86503 8.60628 7.58997 8.97233 7.45032 9.30664Z",
    fill: "#2C62F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcQuestion);
export default __webpack_public_path__ + "static/media/ic-question.74090c589abef9054b07922f7604b5f9.svg";
export { ForwardRef as ReactComponent };